import { formatCurrency } from 'utils/formatCurrency';

import { Price } from '../types/price';

export function calculateTotalPrice(price: Price, quantity: number) {
  if (!price) return;

  return formatCurrency(price * quantity);
}
